import markConversationsReadInReadingPaneStore from '../actions/markConversationsReadInReadingPaneStore';
import markConversationsAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markConversationsAsReadStoreUpdate';
import { getFolderIdForParentComparison } from 'owa-mail-list-store';
import { orchestrator } from 'satcheljs';

export default orchestrator(markConversationsAsReadStoreUpdate, actionMessage => {
    const { conversationIds, tableViewId, isReadValue } = actionMessage;

    markConversationsReadInReadingPaneStore(
        conversationIds,
        isReadValue,
        getFolderIdForParentComparison(tableViewId)
    );
});
